import { SlaTimeFilter } from '@truepill/tpos-types'
import { ReactComponent as TimeIcon } from 'assets/icons/time.svg'
import Select from 'components/Select'
import useFulfillmentQueue, { FulfillmentQueueName } from 'hooks/useFulfillmentQueue'
import { usePlusClient } from 'providers/VisionRouter'
import styled from 'styled-components'
import { bodyPrimaryColor, borderColor, primaryBackgroundColor } from 'styles/styleVariables'

const slaTimeFilterOptions = [
  { label: 'All', value: SlaTimeFilter.All },
  { label: '12-24 Hours', value: SlaTimeFilter.NearlyOverdue },
  { label: '24+ Hours', value: SlaTimeFilter.Overdue },
]

export const slaTimeFilterLabelMap = Object.fromEntries(
  slaTimeFilterOptions.map(option => [option.value, option.label]),
)

const StyledSelectButton = styled(Select)`
  border-color: ${borderColor};
  margin-left: 0.625rem;
  background-color: ${primaryBackgroundColor};
  color: ${bodyPrimaryColor};
  > svg {
    fill: ${bodyPrimaryColor};
  }
  > div {
    > svg {
      fill: ${bodyPrimaryColor};
    }
  }
`
export default function OrderSlaFilterDropdown(): JSX.Element {
  // Handle the change of the SLA filter dropdown
  const {
    routeToMergedQuery,
    currentLocation: { queryMap },
  } = usePlusClient()
  const fulfillmentQueue = useFulfillmentQueue()

  const SLA_SUPPORTED_QUEUES = [
    FulfillmentQueueName.PV1,
    FulfillmentQueueName.Adjudication,
    FulfillmentQueueName.Automation,
    FulfillmentQueueName.Fill,
    FulfillmentQueueName.PV2,
  ]
  const showFilter = fulfillmentQueue && SLA_SUPPORTED_QUEUES.includes(fulfillmentQueue.name)

  if (!showFilter) return <></>

  const slaFilter = queryMap.slaFilter

  const handleChange = (options: { label: string; value: string }[]) => {
    const option = options[0]
    if (!option) return
    // Remove slaFilter from URL when "All" is selected (default state) OR
    // Set slaFilter in URL only when a specific filter is selected
    if (option.value === SlaTimeFilter.All) {
      routeToMergedQuery({ slaFilter: undefined })
    } else {
      routeToMergedQuery({ slaFilter: option.value })
    }
  }

  // Show the selected option or display default option "All"
  const selectedOption = slaTimeFilterOptions.find(opt => opt.value === slaFilter) || slaTimeFilterOptions[0]

  return (
    <StyledSelectButton
      options={slaTimeFilterOptions}
      icon={<TimeIcon />}
      value={selectedOption}
      onChange={handleChange}
      disableClear={true}
      showActive={!!slaFilter}
    />
  )
}
